import { StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  verifyTitle: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: Fonts.size.h3,
    marginVertical: 20,
  },
  verifyDesc: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h5,
  },
  numberText: {
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
    fontSize: Fonts.size.h5,
    marginBottom: 30,
  },
  resendTextDisabled: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6,
    color: Colors.lightGrey,
    textAlign: 'center',
    marginBottom: 20,
  },
  resendText: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6,
    color: Colors.vfRed,
    textAlign: 'center',
    marginBottom: 20,
  },
  button: {
    marginVertical: 10,
  },
})

export default styles
